export default {"src":"/_next/static/media/WhoWeAre_008A.90217595.JPG","height":692,"width":1920};